<div>
    <button (click)="lookAndFeelService.setLookAndFeel(0)">Light</button>
    <button (click)="lookAndFeelService.setLookAndFeel(1)">Dark</button>
</div>